import { css } from '@emotion/react'
import { Gray900, Primary500, Primary600 } from '@mehilainen/mds-customer/colors'
import reactStyleReset from 'react-style-reset/string'

import ExternalIcon from './externalIcon.svg'

const BodyText = css`
  body {
    color: ${Gray900};
    line-height: 1.5;
  }
`

const Links = css`
  a:not(.no-link-styles) {
    &:link {
      color: ${Primary500};
      text-decoration: underline;
    }

    &:visited {
      color: ${Primary500};
    }

    &:focus,
    &:hover {
      color: ${Primary600};
    }
  }

  .no-link-styles {
    text-decoration: none;
  }
`

// ${ExternalIcon} needs to be surrounded by double quotes to work with url() with Vite
// prettier-ignore
const ExternalLinks = css`
  --base-domain: ${process.env.REACT_APP_AV3_BASE_DOMAIN};

  a:not([href*='var(--base-domain)']):not([href^='#']):not([href^='/']):not([href^='tel:']):not(
      .no-external-icon
    ):after {
    display: inline-block;
    content: '';
    width: 16px;
    height: 16px;
    margin-left: 4px;
    background-color: currentColor;
    mask-image: url("${ExternalIcon}");
    vertical-align: text-top;
  }
`

const GlobalStyle = css`
  ${reactStyleReset};

  *,
  *::after,
  *::before {
    box-sizing: border-box;
  }

  ${BodyText};
  ${Links}
  ${ExternalLinks};
`

export default GlobalStyle
